

  document.addEventListener('algolia.hooks.initialize', function () {
    algoliaShopify.hooks.registerHook(
      'beforeAutocompleteCollectionsTemplate',
      function (defaultTemplate, templateOptions) {
        const { html, item } = templateOptions;

        const isArabic = document.documentElement.lang === "ar";
        const isEnglish = document.documentElement.lang === "en";

        const collectionTitle =
          item?.meta?.custom?.arabic_title || item.title;

        const link = isArabic
          ? `/ar/collections/${item.handle}`
          : `/collections/${item.handle}`;

        return html`
          <a href="${link}" class="aa-ItemLink">
            <div class="aa-ItemContent">
              <div class="aa-ItemContentTitle">
                ${isArabic ? collectionTitle : item.title}
              </div>
            </div>
          </a>
        `;
      }
    );
  });
  
  const sleep = (ms, hookName) => new Promise(resolve => {
    setTimeout(resolve, ms);
  });

    document.addEventListener('algolia.hooks.initialize', function() {
    algoliaShopify.hooks.registerHook('beforeAutocompleteAsyncFunction', async function() {
        await sleep(1000, 'beforeAutocompleteAsyncFunction');
    });
    });
document.addEventListener('algolia.hooks.initialize', function() {
  // Example: override product suggestion template
  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteProductTemplate',(
			_defaultTemplate,
			templateOptions,
			distinct,
			itemLink,
			trackSearchAttribution,
		) => {
			// Modify default options, then return them
			const { html, item, components } = templateOptions;
			
      

      const fallback = "https://cdn.shopify.com/s/files/1/0721/9960/2220/files/Content_f84bf220-58e1-47f2-a3f1-0fd9040b65e8.png?v=1779089106";

          const img = item.image || "";

          const image =
            !img ||
            img.toLowerCase().includes("inputdataemtpy") ||
            img.toLowerCase().includes("inputdataempty")
              ? fallback
              : img;
  
    const fullTitle = item.title;
    const isArabic = document.documentElement.lang === "ar";
    const isEnglish = document.documentElement.lang === "en";
    const arabicTitle = item.meta?.custom?.arabic_title || fullTitle;
    const addToCartLabel = isArabic ? "أضف إلى السلة" : "Add to Cart";
    const soldOutLabel = isArabic ? "نفد من المخزون" : "Sold Out";
    const customMetafields = item?.meta?.custom || {};
    const arabicProductType = customMetafields.arabic_vendor || item.vendor;
    const link = isArabic ? `/ar/products/${item.handle}` : `/products/${item.handle}`;
    const silhouette = item.meta?.custom?.silhouette;
    const silhouette_ar = item.meta?.custom?.silhouette_ar;
    const silhouettetext = isArabic ? silhouette_ar : silhouette;

console.log(link)
    const metaDiscount = parseFloat(item.meta?.custom?.discount_percentage || 0);
    let currentPrice = item.price;
    let originalPrice = item.compare_at_price > item.price ? item.compare_at_price : item.price;
    let isOnSale = false;

    if (metaDiscount > 0) {
      originalPrice = item.price;
      currentPrice = item.price * (100 - metaDiscount) / 100;
      isOnSale = true;
    } else if (item.compare_at_price > item.price) {
      isOnSale = true;
    }

    let priceKWD = currentPrice.toFixed(3) + ' OMR';
    let compareAtPriceHtml = isOnSale ? `${originalPrice.toFixed(3)} OMR` : '';

    const offerType = customMetafields.offer_type;
    const offerTypeAr = customMetafields.offer_type_ar;
    const specialOffer = customMetafields.special_offer;
    const specialOfferAr = customMetafields.special_offer_ar;
    const offerPeriod = customMetafields.offer_period;
    const offerPeriodAr = customMetafields.offer_period_ar;
    const newLabel = customMetafields.new;
    const newLabelAr = customMetafields.new_ar;


            // ── SWATCH EXTRACTOR ──────────────────────────────────────
        function extractSwatches(data) {
          if (!data) return [];

          // Convert JSON string to object
          if (typeof data === "string") {
            try {
              data = JSON.parse(data);
            } catch (e) {
              console.error("Invalid swatch JSON", e);
              return [];
            }
          }

          if (!data.swatches || !Array.isArray(data.swatches)) {
            return [];
          }

          const seen = new Set();

          return data.swatches
            .filter((swatch) => {
              if (!swatch.color || !swatch.shopifyImageUrl) return false;

              if (seen.has(swatch.color)) return false;

              seen.add(swatch.color);
              return true;
            })
            .map((swatch) => ({
              color: swatch.color,
              shopifyImageUrl: swatch.shopifyImageUrl,
            }));
        }

        

        // ── SWATCH RENDERER ───────────────────────────────────────
          function renderColorSwatches(item, html) {
            const swatches = extractSwatches(
              item?.meta?.custom?.color_swatch_map
            );

            if (!swatches.length) return html``;

            return html`
              <div class="aldo-color-swatches__grid">
                ${swatches.map(
                  (swatch, index) => html`
                    <div
                      class="aldo-color-swatches__item ${index === 0 ? "active" : ""}"
                      data-color="${swatch.color}"
                      data-image="${swatch.shopifyImageUrl}"
                    >
                      <img
                        src="${swatch.shopifyImageUrl}"
                        alt="${swatch.color}"
                        width="28"
                        height="28"
                      />
                    </div>
                  `
                )}
              </div>
            `;
          }




        const uniqueId = `search-product-${item.objectID}`;
        const colorSwatchesHtml = renderColorSwatches(item, html);

         // ── SINGLE setTimeout — fetch variants, build select, wire swatches ──
        setTimeout(() => {
          const card = document.getElementById(uniqueId);
          if (!card) return;

          const requestToken = `${item.objectID}-${Date.now()}-${Math.random()}`;
          card.dataset.variantDataReady = "false";
          card.dataset.requestToken = requestToken;
          card.dataset.productHandle = item.handle;
          const swatchItems = card.querySelectorAll(".aldo-color-swatches__item");
          const primaryImg = card.querySelector(".aldo-primary-image");
          const productLink = card.querySelector(".aldo-product-link");

          fetch(`/products/${item.handle}.js`)
            .then(r => r.json())
            .then(data => {
              const variants = data.variants;
              if (!card.isConnected) return;

              if (card.dataset.requestToken !== requestToken) {
                return;
              }

              if (card.dataset.productHandle !== item.handle) {
                return;
              }
              if (card.id !== uniqueId) {
                return;
              }
              card.querySelector(".aldo-variant-select")?.remove();
              // Build hidden select with all variants
              const select = document.createElement("select");
              select.className = "aldo-variant-select";
              select.style.display = "none";

              variants.forEach(v => {
                const option = document.createElement("option");
                option.value = v.id;
                option.setAttribute("data-title", v.title);
                option.setAttribute("data-option1", v.option1 || "");
                option.setAttribute("data-option2", v.option2 || "");
                option.setAttribute("data-image", v.featured_image ? v.featured_image.src : "");
                option.setAttribute("data-available", v.available ? "true" : "false");
                option.setAttribute("data-price", v.price);
                option.setAttribute("data-compare-at-price", v.compare_at_price || "");
                option.textContent = v.title;
                select.appendChild(option);
              });

              card.appendChild(select);

              const gridcard = card.querySelector(".aldo-color-swatches__grid");

              if (gridcard) {
                gridcard.querySelector(".aldo-color-swatches__more")?.remove();
              }
              card.querySelectorAll(".aldo-color-swatches__item").forEach(swatch => {
                const color = swatch.dataset.color.toLowerCase().trim();

                // All variants for this color
                const colorOptions = Array.from(select.options).filter(option => {
                  return (
                    (option.dataset.option1 || "").toLowerCase().trim() === color ||
                    (option.dataset.option2 || "").toLowerCase().trim() === color
                  );
                });

                if (!colorOptions.length) return;

                // First available variant, fall back to first
                let selectedOption = colorOptions.find(o => o.dataset.available === "true") || colorOptions[0];

                swatch.setAttribute(
                  "data-variant-id",
                  selectedOption.value || ""
                );

                swatch.setAttribute(
                  "data-available",
                  selectedOption.dataset.available || "false"
                );

                swatch.setAttribute(
                  "data-price",
                  selectedOption.dataset.price || ""
                );

                swatch.setAttribute(
                  "data-compare-at-price",
                  selectedOption.dataset.compareAtPrice || ""
                );

                swatch.setAttribute(
                  "data-image",
                  selectedOption.dataset.image || ""
                );

                
              });


            

              card.dataset.variantDataReady = "true";
              const swatchItemsArr = Array.from(swatchItems);
              const priceEl = card.querySelector(".price b");
              const compareAtEl = card.querySelector(".price-strike");
              // ── Show only the first 4 available swatches; hide unavailable ones
              //    entirely; show "+N" for any remaining available ones beyond 4 ──
              const availableSwatches = swatchItemsArr.filter(s => s.dataset.available === "true");
              const maxVisible = 4;

              swatchItemsArr.forEach(s => {
                if (s.dataset.available !== "true") {
                  s.style.display = "none";
                }
              });

              availableSwatches.forEach((s, i) => {
                s.style.display = i < maxVisible ? "" : "none";
              });

              const grid = card.querySelector(".aldo-color-swatches__grid");

              if (grid) {
                // Always remove any old "+N" indicator first
                const oldMoreEl = grid.querySelector(".aldo-color-swatches__more");

                if (oldMoreEl) {
                  oldMoreEl.remove();
                }

                // Add "+N" only when this product actually has
                // more available colors than we are showing
                if (availableSwatches.length > maxVisible) {
                  const remaining = availableSwatches.length - maxVisible;

                  const moreEl = document.createElement("span");
                  moreEl.className = "aldo-color-swatches__more";
                  moreEl.textContent = `+${remaining}`;

                  grid.appendChild(moreEl);
                }
              }

             
              // ── Single source of truth: activates a swatch and refreshes
              //    active class, image, link, and price together ──
              function activateSwatch(swatch) {
                if (!swatch) return;
                if (card.dataset.variantDataReady !== "true") return;
                swatchItemsArr.forEach(s => s.classList.remove("active"));
                swatch.classList.add("active");

                const variantId = swatch.dataset.variantId;
                const swatchImage = swatch.dataset.image;

                if (primaryImg && swatchImage) {
                  primaryImg.src = swatchImage;
                  primaryImg.srcset = swatchImage;
                }

                if (productLink && variantId) {
                  productLink.href = isArabic
                    ? `/ar/products/${item.handle}?variant=${variantId}`
                    : `/products/${item.handle}?variant=${variantId}`;
                }

                // /products/{handle}.js returns price as an integer in cents,
                // so divide by 100 regardless of the currency's decimal display.
                if (priceEl && swatch.dataset.price) {
                  priceEl.textContent = `${(parseFloat(swatch.dataset.price) / 100).toFixed(3)} OMR`;
                }

                if (compareAtEl) {
                  const compareAt = parseFloat(swatch.dataset.compareAtPrice || "0");
                  const current = parseFloat(swatch.dataset.price || "0");
                  compareAtEl.textContent = (compareAt > current)
                    ? `${(compareAt / 100).toFixed(3)} OMR`
                    : "";
                }
              }

              // ── Decide which swatch should be active on load.
              //    If the template-marked "active" (first) swatch is
              //    unavailable, walk forward to the first available one. ──
              let activeSwatch = card.querySelector(".aldo-color-swatches__item.active");

              if (activeSwatch && activeSwatch.dataset.available === "false") {
                const activeIndex = swatchItemsArr.indexOf(activeSwatch);
                const total = swatchItemsArr.length;

                for (let i = 1; i <= total; i++) {
                  const candidate = swatchItemsArr[(activeIndex + i) % total];
                  if (candidate.dataset.available === "true") {
                    activeSwatch = candidate;
                    break;
                  }
                }
              }

              if (
                  card.dataset.variantDataReady === "true" &&
                  card.querySelector(".aldo-variant-select")
                ) {
                  activateSwatch(activeSwatch);
                }

              // ── Wire swatch clicks ────────────────────────────              
              swatchItemsArr.forEach((swatchItem, index) => {
                swatchItem.addEventListener("mousedown", (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                });

                swatchItem.addEventListener("click", (e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  // If this swatch isn't available, jump to the next available one instead
                  if (swatchItem.dataset.available === "false") {
                    const total = swatchItemsArr.length;
                    for (let i = 1; i <= total; i++) {
                      const nextItem = swatchItemsArr[(index + i) % total];
                      if (nextItem.dataset.available === "true") {
                        nextItem.click();
                        break;
                      }
                    }
                    return;
                  }

                  activateSwatch(swatchItem);
                });
              });
            })
            .catch(e => console.error(`Variant fetch error for ${item.handle}:`, e));
          }, 0);
        
   
    return html`
      <div id="${uniqueId}" class="card-wrapper product-card-wrapper custom-product-card-inner" data-product-handle="${item.handle}" data-product-object-id="${item.objectID}" >

        <div class="card card--standard card--media" style="--ratio-percent: 100%;">
          <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;">
            <div class="card__media">
              <div class="media media--transparent media--hover-effect">
                  <div class="product-badge-container grid-badges">
                    ${
                      metaDiscount > 0
                        ? html`
                          <div class="custom-meta-badge badge-pos-top-left badge-type-discount" style="background-image: url('https://cdn.shopify.com/s/files/1/0885/5112/9335/files/badge_discount.png?v=1777927943');">
                            <div class="badge-text">
                              ${metaDiscount}% ${isArabic ? 'خصم' : 'off'}
                            </div>
                          </div>
                        `
                        : (offerType || offerTypeAr) ? html`
                          <div class="custom-meta-badge badge-pos-top-left badge-type-offer" style="background-image: url('https://cdn.shopify.com/s/files/1/0885/5112/9335/files/badge_offers.png?v=1777927943');">
                            <div class="badge-text ${isArabic ? 'arabic-text' : ''}">
                              ${isArabic ? (offerTypeAr || offerType) : offerType}
                            </div>
                          </div>
                        ` : ''
                    }

                    ${
                      (specialOffer || specialOfferAr)
                        ? html`
                          <div class="custom-meta-badge badge-pos-below-top-left badge-type-special" style="background-image: url('https://cdn.shopify.com/s/files/1/0885/5112/9335/files/badge_left_lower.png?v=1777927944');">
                            <div class="badge-text ${isArabic ? 'arabic-text' : ''}">
                              ${isArabic ? (specialOfferAr || specialOffer) : specialOffer}
                            </div>
                          </div>
                        `
                        : ''
                    }

                    ${
                      (offerPeriod || offerPeriodAr)
                        ? html`
                          <div class="custom-meta-badge badge-pos-top-right badge-type-period" style="background-image: url('https://cdn.shopify.com/s/files/1/0885/5112/9335/files/badge_right_upper.png?v=1777927943');">
                            <div class="badge-text ${isArabic ? 'arabic-text' : ''}">
                              ${isArabic ? (offerPeriodAr || offerPeriod) : offerPeriod}
                            </div>
                          </div>
                        `
                        : ''
                    }

                    ${
                      (newLabel || newLabelAr)
                        ? html`
                          <div class="custom-meta-badge badge-pos-below-top-right badge-type-new" style="background-image: url('https://cdn.shopify.com/s/files/1/0885/5112/9335/files/badge_right_lower.png?v=1777927943');">
                            <div class="badge-text ${isArabic ? 'arabic-text' : ''}">
                              ${isArabic ? (newLabelAr || newLabel) : newLabel}
                            </div>
                          </div>
                        `
                        : ''
                    }
                  </div>
                <img
                  class="motion-reduce aldo-primary-image"
                  src="${algoliaShopify.helpers.renderImage(item, 125).src}"
                  srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
                  sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
                  alt="${item.title}"
                  loading="lazy"
                  width="533"
                />                
              </div>
            </div>
          </div>

          <div class="card__content bg-grid-color">
            <div class="card__information">
              
              <h3 class="card__heading">
                <a
                  class="full-unstyled-link custom-product-title aldo-product-link"
                  href="${itemLink}"
                  onClick="${() => trackSearchAttribution(item)}"
                >                  
                  ${isArabic ? arabicTitle: item.title} - ${silhouettetext}
                </a>
              </h3>

              <div class="price">
                <b>${priceKWD}</b>
                <span class="price-strike">${compareAtPriceHtml}</span>
              </div>

              ${colorSwatchesHtml}

              

              <!-- Add to Cart Form -->
              <div class="quick-add no-js-hidden hidden">
                <form
                  method="post"
                  action="/cart/add"
                  id="quick-add-recommend-${item.id}"
                  accept-charset="UTF-8"
                  class="form"
                  enctype="multipart/form-data"
                  novalidate="novalidate"
                  data-type="add-to-cart-form"
                >
                  <input type="hidden" name="form_type" value="product" />
                  <input type="hidden" name="utf8" value="✓" />
                  <input type="hidden" name="id" value="${item.objectID}" class="product-variant-id" />

                  <button
                    id="quick-add-${item.id}-submit"
                    type="submit"
                    name="add"
                    class="custom-add-to-cart custom-add-to-cart-algolia ${!item.can_order ? 'in_stock_product' : 'out_stock_product'}"
                    aria-haspopup="dialog"
                    aria-labelledby="quick-add-${item.id}-submit title--${item.id}"
                    aria-live="polite"
                    data-sold-out-message="true"
                    ${!item.can_order ? '' : 'disabled'}
                  >
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M8 12L8 8C8 5.79086 9.79086 4 12 4V4C14.2091 4 16 5.79086 16 8L16 12" stroke="#33363F" stroke-width="2" stroke-linecap="round"></path>
                        <path d="M3.69435 12.6678C3.83942 10.9269 3.91196 10.0565 4.48605 9.52824C5.06013 9 5.9336 9 7.68053 9H16.3195C18.0664 9 18.9399 9 19.514 9.52824C20.088 10.0565 20.1606 10.9269 20.3057 12.6678L20.8195 18.8339C20.904 19.8474 20.9462 20.3542 20.6491 20.6771C20.352 21 19.8435 21 18.8264 21H5.1736C4.15655 21 3.64802 21 3.35092 20.6771C3.05382 20.3542 3.09605 19.8474 3.18051 18.8339L3.69435 12.6678Z" stroke="#33363F" stroke-width="2"></path>
                      </svg>
                      
                      ${!item.can_order ? addToCartLabel : soldOutLabel}
                    </span>

                    <span class="sold-out-message hidden">Sold out</span>

                    <div class="loading__spinner hidden">
                      <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                        <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
                      </svg>
                    </div>
                  </button>

                  <input type="hidden" name="product-id" value="${item.id}" />
                  <input type="hidden" name="section-id" value="template--collection-items" />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    `
    }
  );


});